import React from 'react';
import { tokens } from '@happy-design/react';

const HappyPropertySVG = ()=>{
    return React.createElement("svg", {
        enableBackground: "new 0 0 128 129",
        viewBox: "0 0 128 129",
        xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
        clipRule: "evenodd",
        d: "m63.6 9.3c-3.2-.1-6.5 1-9.1 3.2l-40.4 33.9c-3.1 2.6-4.8 6.2-4.9 9.9v1 48c0 7.6 6.1 13.7 13.7 13.7s13.7-6.1 13.7-13.7v-42l27.1-22.7 27.8 23.3v27.8h-27.5c-7.6 0-13.7 6.1-13.7 13.7s6.1 13.7 13.7 13.7h41.1c7.6 0 13.7-6.1 13.7-13.7 0-.1 0-.3 0-.4v-47c.1-4.1-1.5-8.1-4.9-11l-41.1-34.5c-2.7-2.3-6-3.3-9.2-3.2z",
        fill: tokens.color.accent.default,
        fillRule: "evenodd"
    }), React.createElement("path", {
        d: "m64 91.7c7.6 0 13.7 6.1 13.7 13.7s-6.1 13.7-13.7 13.7-13.7-6.1-13.7-13.7 6.1-13.7 13.7-13.7z",
        fill: tokens.color.palette.white[100]
    }), React.createElement("path", {
        clipRule: "evenodd",
        d: "m120.8 104.9v-46.9c.1-4.6-1.8-9.3-5.6-12.5l-41.1-34.5c-3.1-2.6-6.8-3.8-10.5-3.7-3.7-.1-7.4 1.1-10.4 3.7l-40.4 33.9c-3.5 2.9-5.4 7.1-5.6 11.3v1.1 48c0 8.7 7 15.7 15.7 15.7s15.7-7 15.7-15.7v-41l25.1-21 25.8 21.6v24.8h-25c-.1 0-.2 0-.4 0-6 0-11.2 3.3-13.8 8.2-1.2 2.2-1.9 4.8-1.9 7.5 0 8.7 7 15.7 15.7 15.7h41.1c8.7 0 15.7-7 15.7-15.7 0-.2 0-.3-.1-.5zm-45.1.5c0 6.5-5.2 11.7-11.7 11.7s-11.7-5.2-11.7-11.7c0-2 .5-3.9 1.4-5.6 2-3.6 5.9-6.1 10.3-6.1h.4c6.3.2 11.3 5.3 11.3 11.7zm29.4 11.7h-30.7c3.2-2.9 5.3-7.1 5.3-11.7 0-4.7-2-8.8-5.2-11.7h18.9v-30.7l-29.8-25-29 24.4v42.9c0 6.5-5.2 11.7-11.7 11.7s-11.7-5.2-11.7-11.7v-48c0-.3 0-.6 0-.8.1-3.2 1.6-6.3 4.2-8.5l40.4-34c2.3-1.9 5-2.8 7.8-2.7h.1.1c2.8-.1 5.6.8 7.9 2.7l41.1 34.5c2.9 2.4 4.3 5.9 4.2 9.4v47 .4c-.1 6.6-5.4 11.8-11.9 11.8z",
        fill: tokens.color.text.default,
        fillRule: "evenodd"
    }));
};
const HappyAssetSVG = ()=>{
    return React.createElement("svg", {
        enableBackground: "new 0 0 128 128",
        viewBox: "0 0 128 128",
        xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
        clipRule: "evenodd",
        d: "m88 59.3-50.9 50.9c-5.4 5.4-14 5.4-19.4 0s-5.4-14 0-19.4l50.8-50.8h-4-37.1c-7.6 0-13.7-6.1-13.7-13.7s6.1-13.7 13.7-13.7h74.3c7.6 0 13.7 6.1 13.7 13.7v37.1 37.1c0 7.6-6.1 13.7-13.7 13.7s-13.7-6.1-13.7-13.7z",
        fill: tokens.color.accent.default,
        fillRule: "evenodd"
    }), React.createElement("path", {
        d: "m27.4 86.9c7.6 0 13.7 6.1 13.7 13.7s-6.1 13.7-13.7 13.7-13.7-6.1-13.7-13.7 6.2-13.7 13.7-13.7z",
        fill: tokens.color.palette.white[100]
    }), React.createElement("path", {
        d: "m101.7 10.6h-74.3c-8.7 0-15.7 7-15.7 15.7s7 15.7 15.7 15.7h36.3l-47.4 47.4c-6.1 6.1-6.1 16.1 0 22.2.4.4.8.7 1.2 1h.1c2.7 2.2 6.1 3.5 9.9 3.5 4.7 0 8.9-2.1 11.8-5.3l46.7-46.6v36.4c0 8.7 7 15.7 15.7 15.7s15.7-7 15.7-15.7v-37.2-37.1c0-8.7-7-15.7-15.7-15.7zm-65.3 97.5-.7.7c-4.6 4.6-12 4.6-16.5 0-2.1-2.1-3.4-5-3.4-8.3 0-6.5 5.2-11.7 11.7-11.7s11.7 5.2 11.7 11.7c-.1 3-1.1 5.6-2.8 7.6zm77-81.8v37.1 37.1c0 6.5-5.2 11.7-11.7 11.7s-11.7-5.2-11.7-11.7v-41.2-4.8l-3.4 3.4-43.5 43.5c0-.3 0-.5 0-.8 0-8.7-7-15.7-15.7-15.7-.3 0-.6 0-1 0l43.6-43.5 3.4-3.4h-4.8-4-37.2c-6.5 0-11.7-5.2-11.7-11.7s5.3-11.7 11.7-11.7h74.3c6.5 0 11.7 5.2 11.7 11.7z",
        fill: tokens.color.text.default
    }));
};
const HappyForceSVG = ()=>{
    return React.createElement("svg", {
        enableBackground: "new 0 0 128 128",
        viewBox: "0 0 128 128",
        xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
        clipRule: "evenodd",
        d: "m64 121.1c-7.6 0-13.7-6.1-13.7-13.7v-29.7h-29.7c-7.6 0-13.7-6.1-13.7-13.7s6.1-13.7 13.7-13.7h29.7v-29.7c0-7.6 6.1-13.7 13.7-13.7s13.7 6.1 13.7 13.7v29.7h29.7c7.6 0 13.7 6.1 13.7 13.7s-6.1 13.7-13.7 13.7h-29.7v29.7c0 7.6-6.1 13.7-13.7 13.7z",
        fill: tokens.color.accent.default,
        fillRule: "evenodd"
    }), React.createElement("path", {
        d: "m107.4 50.3c7.6 0 13.7 6.1 13.7 13.7s-6.1 13.7-13.7 13.7-13.7-6.1-13.7-13.7 6.2-13.7 13.7-13.7z",
        fill: tokens.color.palette.white[100]
    }), React.createElement("path", {
        clipRule: "evenodd",
        d: "m123.1 64c0-8.7-7-15.7-15.7-15.7-.1 0-.2 0-.4 0h-27.3v-27.7c0-8.7-7-15.7-15.7-15.7s-15.7 7-15.7 15.7v27.7h-27.7c-8.7 0-15.7 7-15.7 15.7s7 15.7 15.7 15.7h27.7v27.7c0 8.7 7 15.7 15.7 15.7s15.7-7 15.7-15.7v-27.7h27.7c8.7 0 15.7-7 15.7-15.7zm-15.7 11.7c-6.5 0-11.7-5.2-11.7-11.7 0-6.3 5-11.5 11.3-11.7h.4c6.5 0 11.7 5.2 11.7 11.7s-5.2 11.7-11.7 11.7zm-31.7 0v31.7c0 6.5-5.2 11.7-11.7 11.7s-11.7-5.2-11.7-11.7v-31.7h-31.7c-6.5 0-11.7-5.2-11.7-11.7s5.2-11.7 11.7-11.7h31.7v-31.7c0-6.5 5.2-11.7 11.7-11.7s11.7 5.2 11.7 11.7v31.7h21.3c-3.2 2.9-5.2 7-5.2 11.7s2.1 8.9 5.3 11.7z",
        fill: tokens.color.text.default,
        fillRule: "evenodd"
    }));
};
const ExpandAllSVG = ()=>{
    return React.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
        d: "M8 9.75L12 5.75L16 9.75",
        stroke: tokens.color.palette.gray[90],
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), React.createElement("path", {
        d: "M16 14.25L12 18.25L8 14.25",
        stroke: tokens.color.palette.gray[90],
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};

export { ExpandAllSVG, HappyAssetSVG, HappyForceSVG, HappyPropertySVG };
